import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; // @ts-check

import json2xml from '../../../utils/json2xml';
import string2xml from '../../../utils/string2xml';
import formatting from '../../../utils/formatting';
export var toXml = function toXml(object, _elementNameFn, collectionSchema) {
  var json = revertCustomSerialization(object, collectionSchema);
  return json2xml(json, {
    elementNameFn: function elementNameFn(name) {
      return _elementNameFn === undefined ? formatting.camelCaseToDash(name) : _elementNameFn(formatting.camelCaseToDash(name));
    },
    attributeNameFn: formatting.camelCaseToDash,
    attributesKey: 'attributes'
  });
};

var revertCustomSerialization = function revertCustomSerialization(currentObject, currentSchema) {
  var json = {
    attributes: []
  };
  Object.keys(currentObject).forEach(function (objectKey) {
    if (objectKey === 'elementName') return;

    if (currentObject[objectKey] === '' || currentObject[objectKey] === undefined || currentObject[objectKey] === null) {
      return;
    }

    if (typeof currentObject[objectKey] !== 'object') {
      json.attributes[objectKey] = currentObject[objectKey];
    } else {
      if (Array.isArray(currentObject[objectKey])) {
        currentObject[objectKey].forEach(function (collectionItem) {
          var parentPropertyName = objectKey; // if an object in an array has the "elementName" property
          // use that value as the name of the property in parent element

          if (collectionItem.elementName !== undefined) {
            parentPropertyName = collectionItem.elementName;
          } else if (currentSchema) {
            Object.keys(currentSchema).forEach(function (schemaKey) {
              if (getCollectionName(currentSchema, schemaKey) === objectKey) parentPropertyName = schemaKey;
            });
          }

          if (json[parentPropertyName] === undefined) json[parentPropertyName] = [];
          json[parentPropertyName].push(revertCustomSerialization(collectionItem, getSchemaObject(currentSchema, parentPropertyName)));
        });
      } else {
        // any element to be added as array for simplicity
        if (json[objectKey] === undefined) json[objectKey] = [];
        json[objectKey].push(revertCustomSerialization(currentObject[objectKey], getSchemaObject(currentSchema, objectKey)));
      }
    }
  });
  return json;
};

export var fromXml = function fromXml(xml, collectionsSchema) {
  var xmlDom = string2xml(xml);
  var xmlObject = fromXmlDom(xmlDom, {}, collectionsSchema);
  setDefaultProperties(xmlObject, collectionsSchema);
  return xmlObject;
}; // make sure the structure and all collections from collections schema
// is present in resulting object even if is missing from xml

var setDefaultProperties = function setDefaultProperties(currentObject, currentSchema) {
  Object.keys(currentSchema).forEach(function (key) {
    if (key === 'parentCollection') return;

    if (typeof currentSchema[key] === 'string') {
      if (currentObject[currentSchema[key]] === undefined) currentObject[currentSchema[key]] = [];
    } else {
      var parentCollection = getCollectionName(currentSchema, key);

      if (parentCollection !== null) {
        if (parentCollection !== undefined) {
          if (currentObject[parentCollection] === undefined) {
            currentObject[parentCollection] = [];
          } else {
            currentObject[parentCollection].forEach(function (collectionItem) {
              setDefaultProperties(collectionItem, getSchemaObject(currentSchema, collectionItem.elementName));
            });
          }
        } else {
          if (currentObject[key] === undefined) currentObject[key] = {};
          setDefaultProperties(currentObject[key], getSchemaObject(currentSchema, key));
        }
      }
    }
  });
};
/**
 * @param {*} xmlDom
 * @param {*} parentObject
 * The collection schema of an xml.
 * This object describes what elements are known to repeat.
 * If the value of a property is a string that is the name of the collection
 * otherwise use the 'parentCollection' property of the value object
 * @param {*} schema
 */


var fromXmlDom = function fromXmlDom(xmlDom, parentObject, schema) {
  for (var index = 0; index < xmlDom.children.length; index++) {
    var currentChild = xmlDom.children[index];
    var propertyName = getPropertyName(currentChild.tagName);

    var elementObject = _objectSpread({}, readAttributes(currentChild.attributes));

    var currentObject = fromXmlDom(currentChild, elementObject, getSchemaObject(schema, propertyName));

    if (!schema) {
      setElementProperty(parentObject, propertyName, currentObject);
    } else {
      var parentCollection = getCollectionName(schema, propertyName);

      if (parentCollection) {
        if (parentObject[parentCollection] === undefined) parentObject[parentCollection] = []; // preserve element name to be able to restore initial collection

        currentObject.elementName = propertyName;
        parentObject[parentCollection].push(currentObject);
      } else {
        setElementProperty(parentObject, propertyName, currentObject);
      }
    }
  }

  return parentObject;
};

var getPropertyName = function getPropertyName(elementName) {
  var namespaceIndex = elementName.indexOf(':');
  var propertyName = formatting.dashToCamelCase(namespaceIndex > -1 ? elementName.substring(namespaceIndex + 1) : elementName);
  return propertyName;
};
/**
 * Elements can repeat. In case it is repeatead the value is converted to an array.
 * This is used when a collection is not defined in the schema object.
 */


var setElementProperty = function setElementProperty(object, propertyName, value) {
  if (object[propertyName] === undefined) {
    object[propertyName] = value;
  } else {
    if (!Array.isArray(object[propertyName])) object[propertyName] = [object[propertyName]];
    object[propertyName].push(value);
  }
};

var readAttributes = function readAttributes(attributes) {
  var attributesObject = {};
  Array.prototype.forEach.call(attributes, function (attribute) {
    return attributesObject[formatting.dashToCamelCase(attribute.name)] = attribute.value;
  });
  return attributesObject;
};

var getSchemaObject = function getSchemaObject(schema, property) {
  if (!schema) return null;
  if (property !== '*' && !schema[property]) return getSchemaObject(schema, '*');
  var value = schema[property];
  return typeof value === 'function' ? value() : value;
};

var getCollectionName = function getCollectionName(schema, elementName) {
  if (elementName != '*' && !schema[elementName]) return getCollectionName(schema, '*');
  if (typeof schema[elementName] === 'string') return schema[elementName];
  if (typeof schema[elementName] === 'object') return schema[elementName].parentCollection;
  if (typeof schema[elementName] === 'function') return schema[elementName]().parentCollection;
  return null;
};